import { forwardRef, memo, useEffect, useImperativeHandle, useRef } from 'react';
import { ICustomAudioRef } from '@/sub-luca-plugin/types';

interface IProps {
    src: string;
    className?: string;
    onTimeupdate?: (currentTime: number, duration: number) => void;
    onPlaying?: () => void;
    onPause?: () => void;
    onEnded?: () => void;
}

const CustomAudio = ({ src, className, onTimeupdate, onPlaying, onPause, onEnded }: IProps, ref: any) => {
    const audioRef = useRef<HTMLAudioElement | null>(null);

    useImperativeHandle(
        ref,
        (): ICustomAudioRef => ({
            play: () => audioRef.current!.play(),
            pause: () => audioRef.current!.pause(),
            seek: (time: number) => {
                audioRef.current!.currentTime = time;
            },
        }),
        []
    );

    useEffect(() => {
        audioRef.current!.ontimeupdate = () => {
            onTimeupdate?.(audioRef.current!.currentTime, audioRef.current!.duration);
        };
        audioRef.current!.onplaying = () => {
            onPlaying?.();
        };
        audioRef.current!.onpause = () => {
            onPause?.();
        };
        audioRef.current!.onended = () => {
            onEnded?.();
        };
    }, []);

    return <audio className={className} src={src} ref={audioRef} />;
};

export default memo(forwardRef(CustomAudio));
